import ExcelResponse from '@/types/app/excelResponse';
import { AxiosInstance } from 'axios';
export async function saveFile(
  url: string,
  file: Blob,
  http: AxiosInstance
): Promise<ExcelResponse> {
  const formData = new FormData();
  formData.append('file', file);

  let resp;
  try {
    resp = await http.post(url, formData, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    });

    return resp.data as ExcelResponse;

  } catch (e) {
    const { response } = e as any;
    return response.data as ExcelResponse;
  }
}
